import React from 'react'
import { trans } from '../../../../_providers/Translation'
import ReservationsStatus from './ReservationsStatus'
import PendingPartnerReservations from './PendingPartnerReservations'
import TimeSeriesChart from './TimeSeriesChart'
// import '../../../../assets/css/ReservationStats.css';
import '../../../../assets/css/RelationshipsDashboard.css'

function Dashboard() {
    return (
        <div className="relationships-dashboard">
            <div className="dashboard-content">
                {/* NEW: Аналитичен модул */}
                <div className="dashboard-widgets">

                    <div className='row'>
                        <div className='col'>
                            <PendingPartnerReservations />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col'>
                            <ReservationsStatus
                                title={trans('labels.reservationsSharedFromPartners')}
                                apiEndpoint="shared-reservations/statistics/received"
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col'>
                            <ReservationsStatus
                                title={trans('labels.reservationsSharedToPartners')}
                                apiEndpoint="shared-reservations/statistics/sent"
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col'>
                            <TimeSeriesChart
                                title={trans('random.notes')}
                                apiEndpoint="shared-reservations/analytics/notes"
                                legendItems={[
                                    { name: trans('random.standardNotes'), color: "#5470c6" },
                                    { name: trans('random.highPriorityNotes'), color: "#ff6b6b" }
                                ]}
                            />
                        </div>
                        <div className='col'>
                            <TimeSeriesChart
                                title={trans('random.notesFromPartners')}
                                apiEndpoint="shared-reservations/analytics/notes-from-partners"
                                legendItems={[
                                    { name: "SMS", color: "#5470c6" },
                                    { name: trans('random.emails'), color: "#91cc75" }
                                ]}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dashboard